import { render } from "./studioAdd.vue?vue&type=template&id=45e3e4e0&scoped=true"
import script from "./studioAdd.vue?vue&type=script&lang=js"
export * from "./studioAdd.vue?vue&type=script&lang=js"

import "./studioAdd.vue?vue&type=style&index=0&id=45e3e4e0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e3e4e0"]])

export default __exports__